<template>
  <b-modal
    id="withdraw-modal"
    centered
    title="Withdraw from your wallet"
    @show="loadBankAccounts"
    @hide="resetData"
    ref="withdraw_modal"
  >
    <div class="modal-wrap">
      <b-row>
        <b-col cols="12">
          <p>You can withdraw a minimum of ₦2,000</p>
          <b-form class="mt-2" @submit="submit" @input="formInput">
            <b-form-group
              label="Amount"
              :invalid-feedback="formErrors.amount"
              :state="fieldState.amount"
            >
              <b-form-input
                id="amount"
                v-model="form.amount"
                :state="fieldState.amount"
                type="number"
                required
                placeholder="Minimum of ₦2,000"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="Select Your Bank Account"
              :invalid-feedback="formErrors.bankaccountid"
              :state="fieldState.bankaccountid"
            >
              <content-placeholders :rounded="true" v-if="loading && !errorLoading">
                <content-placeholders-heading />
              </content-placeholders>
              <b-button
                variant="primary"
                @click="loadBankAccounts"
                v-else-if="errorLoading"
              >Network Error, Please Retry</b-button>
              <b-form-select
                id="bank"
                v-model="form.bankaccountid"
                :options="bankAccounts"
                :state="fieldState.bankaccountid"
                v-else
              ></b-form-select>
            </b-form-group>
            <div class="text-center mt-1">
              <StatefulButton
                :loading="requestingOTP"
                loadingText="Requesting..."
                text="Click to request OTP"
                variant="primary"
                elementType="button"
                @click="requestOTP"
                elementClass="w-100 my-3"
                v-if="!sentOTP"
              />
              <p
                class="text-center text-success my-3 bg-light p-3 d-inline-block mx-auto"
                v-else
              >OTP has been sent to {{ userObj.email }}</p>
            </div>
            <b-form-group :invalid-feedback="formErrors.otp" :state="fieldState.otp">
              <b-form-input
                id="otp"
                v-model="form.otp"
                :state="fieldState.otp"
                type="tel"
                required
                trim
                placeholder="OTP"
              ></b-form-input>
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="light" @click="cancel()">Cancel</b-button>
      <StatefulButton
        :error="error"
        :loading="submitting"
        loadingText="Withdrawing..."
        text="Withdraw"
        variant="primary"
        @click="submit"
      />
    </template>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import StatefulButton from "@/components/actions/StatefulButton";

import {
  validateRequired,
  checkFormErrors,
  validateDigits
} from "@/utils/validators";
import nigerianBanks from "@/utils/nigerianBanks";
import { UserService, BankAccountService } from "@/services";

export default {
  name: "withdraw-modal",
  data() {
    return {
      form: {
        bankaccountid: null,
        amount: null,
        otp: null
      },
      formErrors: {},
      error: false,
      submitting: false,
      loading: false,
      errorLoading: false,
      bankAccounts: [],
      requestingOTP: false,
      sentOTP: false
    };
  },
  components: {
    StatefulButton
  },
  computed: {
    ...mapState(["userObj"]),
    fieldState() {
      return checkFormErrors(this.formErrors);
    }
  },
  methods: {
    bankName(code) {
      return nigerianBanks[code];
    },
    async requestOTP() {
      this.requestingOTP = true;
      try {
        await UserService.requestOTP("withdraw");
        this.sentOTP = true;
        this.requestingOTP = false;
      } catch (err) {
        this.requestingOTP = false;
      }
    },
    async loadBankAccounts() {
      this.errorLoading = false;
      this.loading = true;
      try {
        const { data: accounts } = await BankAccountService.getAll();
        this.loading = false;
        if (accounts.length == 0) {
          this.bankAccounts = { "": "No accounts, please add one" };
          return;
        }
        // Convert for Options
        const bankAccounts = {};
        accounts.forEach(element => {
          bankAccounts[element.id] = `${element.accountnumber} ${this.bankName(
            element.bankcode
          )}`;
        });

        this.bankAccounts = bankAccounts;
      } catch (err) {
        this.errorLoading = true;
      }
    },
    async submit(event) {
      event.preventDefault();
      this.submitting = true;
      try {
        this.validateForm();
        const { message } = await BankAccountService.withdraw({
          ...this.form
        });
        this.$store.dispatch("toast", {
          message
        });
        this.$refs.withdraw_modal.hide();
        setTimeout(() => {
          location.reload();
        }, 1000 * 1.5);
      } catch (err) {
        this.formErrors = err;
        this.error = true;
        this.submitting = false;
      }
    },
    validateForm() {
      const { amount, bankaccountid, otp } = this.form;
      let { errors, valid } = validateRequired({ amount, otp });
      if (!errors.amount) {
        const res = validateDigits(amount, "amount", true);
        errors.amount = res.errors.amount;
        valid = valid && res.valid;
      }
      if (!errors.amount && amount < 2000) {
        errors.amount = "Amount must be at least ₦2,000";
        valid = false;
      }
      if (!errors.bankaccountid && bankaccountid === null) {
        errors.bankaccountid = "Select bank account";
        valid = false;
      }
      if (valid === false) throw errors;
    },
    formInput(event) {
      event.preventDefault();
      this.error = false;
      this.formErrors = {};
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.apply(this));
    }
  }
};
</script>

<style></style>
